import React from 'react'
import { VyneRadio } from '@vynedental/design-system'
import { RadioChangeEvent } from 'antd'

import SelfSchedulingModel from '../../../../models/SelfScheduling'

import './SelfSchedulingOpenURLInRadioGroup.sass'

export type SelfSchedulingOpenURLInRadioGroupProps = {
    openURLIn: Models.SelfSchedulingOpenURLIn
    enabled: boolean
    updateOpenURLIn: (openURLIn: Models.SelfSchedulingOpenURLIn) => void
}

const moduleName = 'self-scheduling-open-url-in-radio-group'

const SelfSchedulingOpenURLInRadioGroup = (props: SelfSchedulingOpenURLInRadioGroupProps) => {
    const { openURLIn = SelfSchedulingModel.defaultOpenURLIn } = props

    const updateOpenURLIn = (e: RadioChangeEvent) => {
        props.updateOpenURLIn(e.target.value as Models.SelfSchedulingOpenURLIn)
    }

    return (
        <div className={`${moduleName} ${!props.enabled ? `${moduleName}--disabled-form` : ``}`}>
            <div className={`${moduleName}__title`}>Open URL in:</div>
            <div className={`${moduleName}__radio-buttons-wrapper`}>
                <div className={`${moduleName}__option-wrapper`}>
                    <VyneRadio
                        dataTestId="update-open-url-in-same-tab"
                        checked={openURLIn === 'same_window'}
                        onChange={updateOpenURLIn}
                        name="radio-widget-style"
                        value="same_window"
                        disabled={!props.enabled}
                        isStandalone
                        style={{ marginBottom: 0 }}
                    >
                        Same Tab
                    </VyneRadio>
                </div>
                <div className={`${moduleName}__option-wrapper`}>
                    <VyneRadio
                        dataTestId="update-open-url-in-new-tab"
                        checked={openURLIn === 'new_tab'}
                        onChange={updateOpenURLIn}
                        name="radio-widget-style"
                        value="new_tab"
                        disabled={!props.enabled}
                        isStandalone
                        style={{ marginBottom: 0 }}
                    >
                        New Tab
                    </VyneRadio>
                </div>
            </div>
        </div>
    )
}

export default SelfSchedulingOpenURLInRadioGroup
